import { request } from './http'

export interface User {
  id: number
  name: string
  email: string
}

interface UserResponse {
  user: User
}

export const authService = {
  async login(email: string, password: string): Promise<User> {
    const { data } = await request<UserResponse>('/v1/login', {
      method: 'POST',
      body: { email, password },
      withSessionId: true,
    })
    return data!.user
  },

  async register(email: string, password: string, name: string): Promise<User> {
    const { data } = await request<UserResponse>('/v1/register', {
      method: 'POST',
      body: { email, password, name },
      withSessionId: true,
    })
    return data!.user
  },

  async logout(): Promise<void> {
    await request('/v1/logout', { method: 'POST' })
  },

  async requestPasswordReset(email: string): Promise<void> {
    await request('/v1/forgot-password', { method: 'POST', body: { email } })
  },

  async resetPassword(token: string, password: string, email: string): Promise<void> {
    await request('/v1/reset-password', {
      method: 'POST',
      body: { token, password, email },
    })
  },

  async fetchUser(): Promise<User | null> {
    try {
      const { data } = await request<User>('/v1/user')
      return data
    } catch {
      return null
    }
  },
}
